import { render, staticRenderFns } from "./data-records-stats.vue?vue&type=template&id=6e71e02c"
import script from "./data-records-stats.vue?vue&type=script&lang=js"
export * from "./data-records-stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports